import script from "./MainContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainContent.vue?vue&type=script&setup=true&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=0d236a80&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d236a80"]])

export default __exports__